import { styled } from 'linaria/react';
import { css } from 'linaria';

export const pravilaUslugInfoBar = css`
	padding: var(--space-200);
	margin: var(--space-200) 0 0 0;
	border: 1px solid var(--control-secondary);
	border-radius: var(--rounding-l);
`;

export const StyledUl = styled.ul`
	display: flex;
	flex-direction: column;
	gap: var(--space-100);
	padding-inline-start: 0;
	margin: var(--space-400) 0 0 0;
	list-style: none;
`;

export const linkButtonStyles = css`
	align-items: start;
`;
